<div class="trusted-certificate setting-page">
  <legend>Trusted Certificates</legend>

  <div class="action-buttons">
    <arm-action-bar (addClick)="addCertificate()" [disableAdd]="isUnauthorized"
                    (refreshClick)="getAllCertificates()"
                    (deleteClick)="deleteCertificate()" [disableDelete]="isUnauthorized || !selection">
    </arm-action-bar>
  </div>

  <div class="web-services-table">
    <arm-table  [isSelectedByDefault]="false"
                [displayedColumns]="displayedColumns"
                (onSelection)="onSelection($event)" [data]="certificates"
                [isMultipleSelection]="false"
                [isClientSide]="true"></arm-table>
  </div>

  <!--  <div class="certificates-container">
      <mat-accordion>
        <mat-expansion-panel *ngFor="let certificate of certificates; let i = index" class="mat-elevation-z0">
          <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'">
            <mat-panel-title>
              <div class="certificate-title" title="{{certificate.alias}}">
                {{certificate.alias}}
              </div>
            </mat-panel-title>
            <mat-panel-description class="remove-certificate">
              <i class="fa fa-trash-o" (click)="deleteCertificate($event, i, certificate)"></i>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <pre>{{certificate.value}}</pre>
        </mat-expansion-panel>
      </mat-accordion>
    </div>-->

</div>
